import React, { FC } from 'react';
import { observer } from 'mobx-react';
import sanitizeHtml from 'sanitize-html';
import { renderToStaticMarkup } from 'react-dom/server';
import { Close } from './icons';
import { ILabelSnapshotIn } from '@stores/LabelStore';
export const DefaultLabelsColors = {
  planned: 'bg-secondary-100',
  ongoing: 'bg-warning-200',
  done: 'bg-positive-200',
  cancelled: 'bg-negative-200',
  'status::planned': 'bg-secondary-100',
  'status::ongoing': 'bg-warning-200',
  'status::done': 'bg-positive-200',
  'status::cancelled': 'bg-negative-200'
};

// The duplication with DefaultLabelsColors may not be avoidable
// Since tailwind expect to find these classes during compilation
export const DefaultLabelsBorderColors = {
  planned: 'border-secondary-100',
  ongoing: 'border-warning-200',
  done: 'border-positive-200',
  cancelled: 'border-negative-200',
  'status::planned': 'border-secondary-100',
  'status::ongoing': 'border-warning-200',
  'status::done': 'border-positive-200',
  'status::cancelled': 'border-negative-200'
};
export const colorIsLight = (htmlCode: string) => {
  const color = +('0x' + htmlCode.slice(1));
  const r = color >> 16;
  const g = color >> 8 & 255;
  const b = color & 255;

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
  return hsp > 127.5;
};
export const splitScopedLabel = label => {
  const index = label.indexOf('::');
  const scoped = index !== -1;
  return {
    scope: scoped ? label.slice(0, index) : '',
    name: scoped ? label.slice(index + 2) : label
  };
};
type CoreLabel = Pick<ILabelSnapshotIn, 'id' | 'name' | 'color'> & Partial<Omit<ILabelSnapshotIn, 'id' | 'name' | 'color'>>;
export const LFLabel: FC<{
  label: CoreLabel;
  onClickRemove?: (e: React.MouseEvent<HTMLElement>) => void;
}> = observer(({
  label,
  onClickRemove
}) => {
  const {
    scope,
    name
  } = splitScopedLabel(label.name);
  return <div data-tooltip-place="bottom" data-tooltip-id="main-tooltip" data-tooltip-html={renderToStaticMarkup(<div className="text-center">
          <p className="font-medium">{sanitizeHtml(label.name)}</p>
          {label.description && <p className="max-w-72">{sanitizeHtml(label.description)}</p>}
        </div>)}>
      <div className={`
          flex w-fit min-w-max cursor-default rounded-full border-2 text-sm font-light
          lg:text-lg
        `} style={{
      backgroundColor: scope ? 'white' : label.color,
      borderColor: label.color
    }}>
        <div className="flex max-w-72 flex-row">
          {scope && <div className={`
                ${colorIsLight(label.color) ? 'text-black' : ''}
                -ml-1 truncate rounded-l-full pr-3 pl-4 text-white
              `} style={{
          backgroundColor: label.color,
          borderColor: !scope ? label.color : ''
        }}>
              {scope}
            </div>}
          <div className={`
              truncate px-3
              ${scope ? 'max-w-52 text-black' : colorIsLight(label.color) ? 'text-black' : 'text-white'}
            `}>
            {name}
          </div>
        </div>

        {!label.readOnly && onClickRemove && <div onClick={onClickRemove}>
            <Close className={`
                mr-2 h-6 cursor-pointer
                ${!scope && 'text-white'}
              `} />
          </div>}
      </div>
    </div>;
});